import { SET_ADDEVENT } from '../actions';

const eventadd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDEVENT:
      return [...action.value];  
    default: return state;
  }
}

export default eventadd;
